module.exports = __webpack_public_path__ + "img/record-vinyl.28665d13.svg";